import React from 'react';
import LoginFrom from './loginFrom';
import { authenticationService } from '../../apiAuthorization/authenticationService';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        // redirect to home if already logged in
        if (authenticationService.currentUserValue) {
            this.props.history.push('/');
        }
    }

    render() {
        return (
            <div id="login">                
                <LoginFrom props={this.props}/>
            </div>
        )
    }
}

export default LoginPage;